import { ACCEPTANCE_STATUS_CONFIG } from 'modules/proposals';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  publishStatus: PublishStatus;
  index: number;
}

export const SearchResultsAcceptanceStatusIcon: React.FC<Props> = ({
  publishStatus,
  index,
}) => {
  const status = ACCEPTANCE_STATUS_CONFIG[publishStatus];

  return (
    <div
      className={`search__results__acceptance-status text--xtny ${status.className}`}
      data-cy={`proposal-search-list-item-publish-status-${index}`}
    >
      <span className="search__results__acceptance-status__label">
        <FormattedMessage id={status.messageId} />
      </span>
    </div>
  );
};
